import React, { useEffect, useState } from "react";
import styles from "./multipleCheck.module.css";
// import { pickersLayoutClasses } from '@mui/x-date-pickers-pro/PickersLayout';
import { Popover } from "antd";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import SubmitButton from "../submitButton/SubmitButton";
import TextComponent from "../textComponent/TextComponent";

const MultipleCheck = ({
  data = [],
  displayCheckBox,
  Inner_ContainerStyle,
  rangePickerInput,
  rangePickerText,
  label,
  disabled,
}) => {
  const [value, setValue] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    return () => {
      setOpen(false);
    };
  }, []);

  const handleSelect = (item) => {
    setValue((prev) => {
      const isSelected = prev.find((val) => val.name === item.name);
      if (isSelected) {
        return prev.filter((val) => val.name !== item.name);
      } else {
        return [...prev, item];
      }
    });
  };

  const content = (
    <div className={`${styles.Inner_Container} ${Inner_ContainerStyle} `}>
      {data.map((item) => {
        const isSelected = value.find((val) => val.name === item.name);
        return (
          <div
            key={item.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "10px 10px",
              gap: "10px",
              cursor: "pointer",
              backgroundColor: isSelected ? "#C4CBDF" : "transparent",
            }}
          >
            <TextComponent text={item.name} />
            {displayCheckBox ? (
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => handleSelect(item)}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );

  return (
    <div className={styles.container}>
      <Popover
        open={disabled ? false : open}
        placement="bottom"
        style={{ padding: "0px", width: "200px" }}
        content={content}
        trigger="click"
        disabled={disabled}
      >
        <div
          onClick={() => setOpen(!open)}
          //  className={styles.rangePicker} >
          className={`${styles.rangePicker} ${rangePickerInput} `}
        >
          <TextComponent
            // className={styles.rangePickerText}
            className={`${styles.rangePickerText} ${rangePickerText} `}
            // text={
            //   value.length > 0
            //     ? value.map((v) => String(v.name.slice(0, 3))).join(" - ")
            //     : "Operation Days"
            // }
            text={label}
          />
          {disabled ? null : open ? (
            <FaCaretUp size={20} color="var(--secondary-color)" />
          ) : (
            <FaCaretDown size={20} color="var(--secondary-color)" />
          )}
        </div>
      </Popover>
    </div>
  );
};

export default MultipleCheck;
